import * as React from 'react';

import { cn } from '../utils';

export interface DataGridStickyCellProps
  extends React.HTMLAttributes<HTMLDivElement> {
  /** Absolute top position */
  top: number;
  /** Cell width */
  width: number;
  /** Cell height */
  height: number;
  /** Additional CSS classes */
  className?: string;
}

/**
 * Individual sticky column cell for virtualized data grid.
 * Positioned absolutely within the sticky column container.
 */
export const DataGridStickyCell = React.forwardRef<
  HTMLDivElement,
  DataGridStickyCellProps
>(({ top, width, height, className, children, ...props }, ref) => {
  return (
    <div
      role="table-cell"
      ref={ref}
      className={cn(
        'absolute left-0 flex items-center bg-white border-b border-r border-grey-5 px-6',
        className,
      )}
      style={{
        top,
        width,
        height,
      }}
      {...props}
    >
      {children}
    </div>
  );
});

DataGridStickyCell.displayName = 'DataGridStickyCell';
